export default function Intro() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Intro</h1>
    </div>
  );
}
